module.exports = __webpack_public_path__ + "media/images/mobile/dummy05-7846c3d4f6ad49d832ccff69a5a50ab7.jpg";